import { Observable } from 'rxjs';
import { useObservableState } from 'observable-hooks';

export function useObservable<T>($$: [Observable<T>, T]): T {
  return useObservableState(...$$);
}
